import {Brick, registerBrick, BrickContext, User, ErrorFlow} from 'olympe';
import {getLogger} from '@olympeio/core';

/**
 *
 */
export default class SetUserPassword extends Brick {

    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (user, password) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {*} user
     * @param {string} password
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(*)} setUser
     */
    onUpdate(context, [user, password], [forwardEvent, setErrorFlow, setUser]) {
        const transaction = context.getTransaction();

        const login = /** @type {string} */ (this.db.getProperty(user, User.loginProp));
        // Generate SRP authentication data from the password
        const srpClient = new SRPClient();
        const salt = srpClient['generateRandomSalt']();
        const verifier = srpClient['generateVerifier'](salt, login, password);

        // Update user
        const update = transaction.update(user);
        update.setProperty(User.saltProp, salt);
        update.setProperty(User.verifierProp, verifier);

        context.releaseTransaction((executed, success, error) => {
            setUser(user);
            if (!success) {
                // In case of error, dispatch the error flow
                getLogger('SetUserPassword').error(error);
                setErrorFlow(ErrorFlow.create(
                    'Connected user is not allowed to change password',
                    401,
                ));
            } else {
                // Otherwise dispatch the control flow
                forwardEvent();
            }
        });
    }
}

registerBrick('017ae373a76b0f718ce8', SetUserPassword);
